<template>
  <div>
    <img :src="LogoImage" alt="logo" class="h-12 opacity-70 brightness-0 invert xl:h-16" />
  </div>
</template>

<script lang="ts" setup>
import LogoImage from "@/assets/images/logo.svg";
</script>
